import { dayjs, formatDate } from '@shared/utils';

import { type ExamEventData } from '../providers';

import { type Room } from './types';

export function formatRoomData(room: NonNullable<ExamEventData['rooms']>[number]): Room {
  return {
    id: room.id,
    name: room.name,
    seat: room.seat,
    floor: room.floor,
    roomNumber: room.roomNumber ?? '',
    building: room.building.nameTh,
  };
}

export function formatExamDateModal(examStartedAt: Date, examEndedAt: Date): string {
  const startedAt = dayjs(examStartedAt);
  const endedAt = dayjs(examEndedAt);

  // 05-05-2026, 09:30 - 12:00
  const examDate = startedAt.format('DD-MM-YYYY');
  const startTime = startedAt.format('HH:mm');
  const endTime = endedAt.format('HH:mm');

  return `${examDate}, ${startTime} - ${endTime}`;
}

export function formatExamDate(examStartedAt: Date, examEndedAt: Date): string {
  const startedAt = dayjs(examStartedAt);
  const endedAt = dayjs(examEndedAt);

  const weekday = startedAt.format('dddd');
  const examDate = formatDate(examStartedAt);
  const startTime = startedAt.format('HH:mm');
  const endTime = endedAt.format('HH:mm');

  return `วัน${weekday}ที่ ${examDate}, ${startTime} - ${endTime} น.`;
}

export function formatExamDateOnly(examDate: Date): string {
  const date = dayjs(examDate);

  const weekday = date.format('dddd');
  const formattedDate = formatDate(examDate);

  return `วัน${weekday}ที่ ${formattedDate}`;
}

export function formatExamTime(examStartedAt: Date, examEndedAt: Date): string {
  const startedAt = dayjs(examStartedAt);
  const endedAt = dayjs(examEndedAt);

  const startTime = startedAt.format('HH:mm');
  const endTime = endedAt.format('HH:mm');

  return `${startTime} - ${endTime} น.`;
}
